import {createStyles} from '@mantine/core';

/** Layout shared by the full-size file preview modals. */
export const useFilePreviewModalStyles = createStyles((theme) => ({
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    margin: 'auto',
    maxWidth: '95vw',
  },
  body: {
    paddingTop: theme.spacing.sm,
  },
  preview: {
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
    height: 'min(560px, 65vh)',
    minHeight: 320,
    overflow: 'auto',
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[3]}`,
  },
}));
